
import { useState, useEffect } from 'react';
import { useVezgoContext } from '../context/VezgoContext';
import { logger } from '@/services/LoggingService';
import { useVezgoProgress } from './useVezgoProgress';
import { VezgoCallbackResult } from '../types';

interface UseVezgoStateProps {
  provider?: string;
}

export function useVezgoState(props?: UseVezgoStateProps) {
  const vezgoContext = useVezgoContext();
  const [isInitialized, setIsInitialized] = useState(false);
  
  // Get the progress actions from our progress hook
  const progressActions = useVezgoProgress(vezgoContext.actions);

  useEffect(() => {
    if (!isInitialized && !vezgoContext.state.isLoading) {
      logger.debug('useVezgoState', 'Hook initialized with context state', {
        isConnected: vezgoContext.state.isConnected,
        provider: vezgoContext.state.provider,
        hasAccounts: vezgoContext.state.accounts?.length > 0
      });
      setIsInitialized(true);
    }
  }, [isInitialized, vezgoContext.state.isLoading]);

  // Create a combined state object with original state, actions and progress actions
  return {
    ...vezgoContext.state,
    ...vezgoContext.actions,
    ...progressActions,
    // We need to add the missing refreshAttempts property that Investments.tsx is using
    refreshAttempts: 0, // This will be enhanced in future updates
  };
}
